/* src/app/shared-components/mb-confirm-dialog/mb-confirm-dialog.component.scss */
:host {
  position: fixed;
  inset: 0;
  z-index: 20000;
}
.overlay {
  position: absolute;
  inset: 0;
  background: rgba(22, 33, 51, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
.dialog {
  width: 100%;
  max-width: 520px;
  background: #fff;
  border-radius: 0.85rem;
  padding: 1.5rem 1.5rem 1.25rem 1.5rem;
  box-shadow: 0 12px 28px rgba(22, 33, 51, 0.24);
}
.dialog h3 {
  margin: 0 0 0.75rem 0;
  font-size: 2rem;
}
.dialog p {
  margin: 0;
  font-size: 1.5rem;
  line-height: 1.4;
  color: rgba(94, 110, 130, 0.95);
}
.actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1.2rem;
}
@media (max-width: 640px) {
  .actions {
    flex-direction: column;
  }
}
/*# sourceMappingURL=mb-confirm-dialog.component.css.map */
